import React from "react";
import { css, cx } from "emotion";

const TextInput = ({ className, ...rest }) => {
  return (
    <input
      {...rest}
      className={cx(
        css`
          display: block;
          appearance: none;
          font-size: 1em;
          border-radius: 4px;
          margin: 10px 0;
          padding: 1em 1.5em;
          border: 1px solid #ddd;
        `,
        className
      )}
    />
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js